export const SW_INIT = 'SW_INIT';
export const SW_UPDATE = 'SW_UPDATE';
export const UPDATE_CHRONOMETER = 'UPDATE_CHRONOMETER';
export const UPDATE_CHRONOMETER_SESSIONS = 'UPDATE_CHRONOMETER_SESSIONS';
export const UPDATE_ACTIVE_MEETING_CHRONOMETER =
  'UPDATE_ACTIVE_MEETING_CHRONOMETER';
export const UPDATE_URL_VIDEO_SESSION = 'UPDATE_URL_VIDEO_SESSION';
export const UPDATE_COUNTRIES = 'UPDATE_COUNTRIES';
